import { CertificationConfirmDialog } from "../../shared/ui";
import type { BibliotecaDocumento } from "../types/biblioteca";

type Props = {
  document: BibliotecaDocumento | null;
  deleting: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
};

export function BibliotecaDeleteDialog({
  document,
  deleting,
  error,
  onClose,
  onConfirm,
}: Props) {
  if (!document) return null;

  return (
    <>
      <CertificationConfirmDialog
        open
        title="Eliminar documento"
        eyebrow="Biblioteca documental"
        description={`Se eliminarán el registro y el archivo PDF de S3: ${document.nombre_documento}. Esta acción no se puede deshacer.`}
        confirming={deleting}
        onClose={onClose}
        onConfirm={onConfirm}
      />
      {error ? <div className="biblioteca-dialog-error" role="alert">{error}</div> : null}
    </>
  );
}
